import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const anchorNavigationButtonFn = /* @__PURE__ */ createRecipe('anchor-navigation-button', {}, [])

const anchorNavigationButtonVariantMap = {}

const anchorNavigationButtonVariantKeys = Object.keys(anchorNavigationButtonVariantMap)

export const anchorNavigationButton = /* @__PURE__ */ Object.assign(memo(anchorNavigationButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'anchorNavigationButton',
  __getCompoundVariantCss__: anchorNavigationButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: anchorNavigationButtonVariantKeys,
  variantMap: anchorNavigationButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, anchorNavigationButtonVariantKeys)
  },
  getVariantProps: anchorNavigationButtonFn.getVariantProps,
})